export default __webpack_public_path__ + "static/media/cartreport.d1d1944d.svg";